import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";
import { replaceSubdomain } from "utils/history";

import { SharedModuleData } from "../../../gql";

const SharedModulesTableNameCell = ({
  item: sharedModule,
  ...cellProps
}: TableSimpleCellProps<SharedModuleData>) => {
  const moduleOrigin = replaceSubdomain(window.location.origin, sharedModule.ownerSubdomain);

  const moduleUrl = `${moduleOrigin}/module/${sharedModule.id}`;

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={moduleUrl}>{sharedModule.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default SharedModulesTableNameCell;
